module.exports = __webpack_public_path__ + "fonts/Jost-ExtraBold.65d4cb8.ttf";